module.exports = __webpack_public_path__ + "img/photo_betim.4cf1a60a.png";